import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { SIDE_SHEET_SIZE } from './constants.js';
import { Direction } from '../../contexts/session/Locale.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var defaultProps = {
  size: 's',
  placement: 'end'
};
var mapContainerBoxBorderRadius = function mapContainerBoxBorderRadius(direction, placement) {
  if (direction === Direction.LTR) {
    return placement === 'start' ? ['0', '16', '16', '0'] : ['16', '0', '0', '16'];
  }
  return placement === 'start' ? ['16', '0', '0', '16'] : ['0', '16', '16', '0'];
};
var mapContainerBoxTransform = function mapContainerBoxTransform(direction, placement) {
  var isLTR = direction === Direction.LTR;
  var isEnd = placement === 'end';
  if (isLTR) return isEnd ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)';
  return isEnd ? 'translate3d(-100%, 0, 0)' : 'translate3d(100%, 0, 0)';
};
var mapContainerBoxWidth = function mapContainerBoxWidth(screenSize, size) {
  return SIDE_SHEET_SIZE[screenSize][size || 's'];
};
var mapContainerBoxPosition = function mapContainerBoxPosition(direction, placement) {
  var isLTR = direction === Direction.LTR;
  var position = {
    left: placement === 'start' && isLTR ? '0' : undefined,
    right: placement === 'end' && isLTR ? '0' : undefined
  };
  if (!isLTR) {
    if (placement === 'start') {
      position.right = '0';
    } else if (placement === 'end') {
      position.left = '0';
    }
  }
  return position;
};
var getFocusTrapProps = function getFocusTrapProps(visible) {
  return {
    display: 'flex',
    open: visible
  };
};
var getContainerBoxStaticProps = function getContainerBoxStaticProps() {
  return {
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    height: '100%',
    overflowY: 'auto',
    role: 'dialog',
    'aria-modal': 'true',
    bottom: '0',
    backgroundColor: 'base.surface'
  };
};
var getContainerBoxAriaProps = function getContainerBoxAriaProps(title, subtitle, ariaLabel, labelledBy, describedBy) {
  var ariaProps = title ? _objectSpread({
    'aria-labelledby': labelledBy
  }, subtitle && {
    'aria-describedby': describedBy
  }) : {
    'aria-label': ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : 'dialog'
  };
  return ariaProps;
};

export { defaultProps, getContainerBoxAriaProps, getContainerBoxStaticProps, getFocusTrapProps, mapContainerBoxBorderRadius, mapContainerBoxPosition, mapContainerBoxTransform, mapContainerBoxWidth };
//# sourceMappingURL=SideSheet.mappers.js.map
